import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import { CreditCheck } from '../../../models';
import { TmsWebBaseService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class XeroService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('XeroAccounts', httpService);
  }

  getInvoices(customerName: string): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/GetInvoices?customer=${customerName}`);
  }

  getCreditNotes(customerName: string): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/GetCreditNotes?customer=${customerName}`);
  }

  getPayments(customerName: string): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/GetPayments?customer=${customerName}`);
  }

  getCreditCheck(id: string): Observable<CreditCheck> {
    return this.httpService.get<CreditCheck>(`${this.apiUrl}/CustomerCreditCheck?id=${id}`);
  }

  postSalesInvoices(ids: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/CreateSalesInvoices`, { ids });
  }

  postPurchaseInvoices(ids: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/CreatePurchaseInvoices`, { ids });
  }
}
